var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.944 25.708 3.246-3.246A7.5 7.5 0 0 0 22.462 12.19l3.246-3.246A12 12 0 0 1 8.944 25.708zm-2.652-2.652A12 12 0 0 1 23.056 6.292L19.81 9.538A7.5 7.5 0 0 0 9.538 19.81l-3.246 3.246zM28 7a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM4 31a3 3 0 1 1 0-6 3 3 0 0 1 0 6z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcx);
export default __webpack_public_path__ + "static/media/ICX.68e86834fc9da2fd6ca6a3046a7ebabf.svg";
export { ForwardRef as ReactComponent };